import { useCallback, useMemo } from "react";
import * as constantes from "../../../common/Constantes";
import ConfigUtils from "../../../utils/Config";
import { ISimpleUser } from "../../config/Empleados";
import IHoliday from "../../../types/Holiday";
import { View } from "react-big-calendar";

export const useAgendaMemo = ({
  sanitarios,
  holidays,
}: {
  sanitarios: ISimpleUser[];
  holidays: IHoliday[];
}) => {
  // Color del evento
  const eventPropGetter = useCallback(
    (event: any) => ({
      style: {
        backgroundColor:
          event.resource === null
            ? constantes.colorFestivos
            : Object.keys(event.resource).length === 0
            ? constantes.colorNoDisponible
            : sanitarios.find((s) => s.internalID === event.resource.especialista)?.color,
        border: "none",
        opacity: event?.resource?.asistencia === false ? "0.5" : "1",
      },
    }),
    [sanitarios]
  );

  // Color de los días festivos
  const dayPropGetter = useCallback(
    (day: Date) => ({
      style: {
        backgroundColor:
          ConfigUtils.formatEvents(holidays).some(
            (festivo) => ConfigUtils.isSameLocalDay(festivo.start, day)
          )
            ? constantes.colorBackgroundFestivos
            : "transparent",
      },
    }),
    [holidays]
  );

  // Mensajes del calendario
  const messages = useMemo(
    () => ({
      next: ">",
      previous: "<",
      today: "Hoy",
      month: "Mes",
      work_week: "Semana laboral",
      week: "Semana",
      day: "Día",
      showMore: (total: number) => `${total} más`,
      date: "Fecha",
      time: "Hora",
      event: "Evento",
    }),
    []
  );

  // Vistas disponibles
  const calendarViews: View[] = useMemo(
    () => ["day", "work_week", "week", "month"],
    []
  );

  return {
    eventPropGetter,
    dayPropGetter,
    messages,
    calendarViews,
  };
};